// @flow
import React, { Component } from 'react';

import PropertyItem from '../PropertyItem';
import { S } from '../../pages/Docs';
import type { Property } from '../../reducers/version';

import { borderBottom } from './style.css';

type Props = {
  version: string;
  properties: Array<Property>;
};

class PropertyList extends Component<void, Props, void> {
  render() {
    const { props: { version, properties } } = this;

    if (properties.length) {
      return (
        <div className={borderBottom}>
          <h3 className="mv0">
            Properties
          </h3>
          <ul className={`list mv0 pa0 ${S.list}`}>
            {properties.map((item, index) => (
              <PropertyItem key={index} {...item} version={version} />
            ))}
          </ul>
        </div>
      );
    }

    return <div />;
  }
}

export default PropertyList;



// WEBPACK FOOTER //
// ./src/components/PropertyList/index.jsx